import React from "react";
import { FormGroup, OverlayTrigger, Popover } from "react-bootstrap";
import { Validator, Form } from "../widgets";

const EquipmentBoolean = (props) => (
  <>
    <Form.Cell>
      <FormGroup className="boolean-checklist"  style={{paddingTop: '15px'}}>
        <Validator validation={props.validation}>
          <Form.Check
            type="checkbox"
            label={props.name}
            name={props.key_name}
            defaultChecked={props.value}
            onChange={props.onChange}
          />
          <Validator.Text />
        </Validator>
        {props.hint && <OverlayTrigger
          placement="top"
          overlay={
            <Popover>
              <Popover.Content>{props.hint}</Popover.Content>
            </Popover>
          }
        >
          {props.hint && <i className="fa fa-info-circle" aria-hidden="true" />}
        </OverlayTrigger>}
      </FormGroup>
    </Form.Cell>
  </>
);

export default EquipmentBoolean;